import { Checkbox } from "@/components";
import { APPROVALS_FILTERS_NAME } from "../../constants";
import { FC, useMemo } from "react";
import { FilterContentProps } from "./types";
import styles from "./styles.scss";

export const FilterContent: FC<FilterContentProps> = ({
  filters,
  onFilterCheck,
  onClearAll,
  onClose,
  onApplyFilters,
}) => {
  const checkedFiltersLength = useMemo(
    () => Object.values(filters).filter(Boolean).length,
    [filters],
  );

  const handleFilterApply = () => {
    onClose();
    onApplyFilters();
  };

  return (
    <div className={styles.filtersWrapper}>
      <ul className={styles.filters}>
        {Object.entries(filters).map(([key, value]) => (
          <li key={key} className={styles.filter}>
            <Checkbox
              checked={value}
              onChange={() => onFilterCheck(key, value)}
            >
              <p>{APPROVALS_FILTERS_NAME[key]}</p>
            </Checkbox>
          </li>
        ))}
      </ul>
      <hr className={styles.border} />
      <div className={styles.filtersButtons}>
        <button className={styles.filtersButtonsClear} onClick={onClearAll}>
          Clear all
        </button>
        <button
          className={styles.filtersButtonsApply}
          onClick={handleFilterApply}
        >
          Apply {checkedFiltersLength > 0 && `(${checkedFiltersLength})`}
        </button>
      </div>
    </div>
  );
};
